import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import NotListedLocationIcon from "@mui/icons-material/NotListedLocation";

export const GoogleMapsLegend = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div id="legend">
      <IconButton
        onClick={handleClick}
        size="small"
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        style={{
          marginRight: 10,
          backgroundColor: "#fff",
          borderRadius: 2,
        }}
      >
        <NotListedLocationIcon fontSize="large" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        //anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Grid
          container
          direction="column"
          // justify="center"
          alignItems="center"
          style={{ height: 36, cursor: "default" }}
        >
          <Grid item>
            <Typography style={{ fontWeight: "bold" }}>
              {t("appointments.mapInfo")}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <MenuItem disabled className="disabledOverride">
          <img
            style={{ width: 36, height: 36 }}
            src={"../src/_images/SameDayIcon.png"}
            alt=""
          />
          {t("appointments.sameDayLoc")}
        </MenuItem>
        <MenuItem disabled className="disabledOverride">
          <img
            style={{ width: 36, height: 36 }}
            src={"../src/_images/LocationsIcon.png"}
            alt=""
          />
          {t("appointments.standardLoc")}
        </MenuItem>
      </Menu>
    </div>
  );
};
